const objectDeleteNulls = objectOfdata => {
  const objectScopped = { ...objectOfdata }
  Object.keys(objectScopped).forEach(keyname => {
    if (!objectScopped[keyname]) {
      delete objectScopped[keyname]
    }
  })
  return objectScopped
}

export default objectDeleteNulls
